<template>
  <v-content style="background-color: #F8F8F8;margin-bottom: 8rem">
    <!-- Tab Menu -->
    <v-layout class="justify-center">
      <v-flex mt-4 xs12>
        <SlideGroupPortfolio
          :onClickCollection="getCollectionById"
        ></SlideGroupPortfolio>
      </v-flex>
    </v-layout>

    <!-- Body -->
    <v-card flat color="#F8F8F8">
      <loading
        color="#FD5246"
        :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="false"
      ></loading>

      <v-layout class="justify-center" mb-12>
        <v-flex class="xs12 px-lg-0 px-md-0 px-sm-0 px-5">
          <!-- Navication -->
          <v-layout
            class="mt-4 d-flex align-center"
            v-if="$vuetify.breakpoint.mdAndUp"
          >
            <v-flex shrink>
              <span
                style="font-size: 22px"
                :style="{
                  'font-size': $vuetify.breakpoint.lgAndUp
                    ? '22px'
                    : '' || $vuetify.breakpoint.mdAndUp
                    ? '22px'
                    : '' || $vuetify.breakpoint.smAndUp
                    ? '22px'
                    : '' || $vuetify.breakpoint.smAndDown
                    ? '11px'
                    : '',
                }"
              >
                {{
                  switchLanguage === "th"
                    ? category_collection_data.category_collection_name_th
                    : category_collection_data.category_collection_name_en
                }}
              </span>
            </v-flex>
            <v-flex shrink class="mx-2">
              <v-icon v-if="$vuetify.breakpoint.smAndUp" color="#000"
                >navigate_next</v-icon
              >
              <v-icon v-else small color="#000">navigate_next</v-icon>
            </v-flex>
            <v-flex shrink>
              <span
                style="color: #FD5246"
                :style="{
                  'font-size': $vuetify.breakpoint.lgAndUp
                    ? '22px'
                    : '' || $vuetify.breakpoint.mdAndUp
                    ? '22px'
                    : '' || $vuetify.breakpoint.smAndUp
                    ? '22px'
                    : '' || $vuetify.breakpoint.smAndDown
                    ? '11px'
                    : '',
                }"
              >
                {{
                  switchLanguage === "th"
                    ? collections_by_id.collection_name_th
                    : collections_by_id.collection_name_th
                }}
              </span>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex shrink class="d-flex align-center">
              <v-icon class="mr-2">remove_red_eye</v-icon>
              <span>{{ total }}</span>
            </v-flex>
            <v-divider class="mx-4" vertical></v-divider>
            <v-flex class="text-end" shrink>
              <v-layout>
                <!-- Share Facebook -->
                <v-flex mr-3 shrink>
                  <ShareNetwork
                    :title="collections_by_id.collection_name_th"
                    id="share-collection-facebook"
                    network="facebook"
                    :url="
                      `${url}api/share-collection-facebook/` +
                        $route.query.collection_id
                    "
                  ></ShareNetwork>
                  <v-btn
                    depressed
                    small
                    color="#4365FF"
                    @click="share('facebook')"
                  >
                    <v-icon small color="#fff" class="mr-2">share</v-icon>
                    <i
                      style="color: #fff; font-size: 20px"
                      class="fab fa-facebook"
                    ></i>
                  </v-btn>
                </v-flex>
                <!-- Share Twitter -->
                <v-flex shrink>
                  <ShareNetwork
                    :title="collections_by_id.collection_name_th"
                    id="share-collection-twitter"
                    network="twitter"
                    :url="
                      `${url}api/share-collection-twitter/` +
                        $route.query.collection_id
                    "
                  ></ShareNetwork>
                  <v-btn
                    depressed
                    small
                    color="#49B1FF"
                    @click="share('twitter')"
                  >
                    <v-icon small color="#fff" class="mr-2">share</v-icon>
                    <i
                      style="color: #fff; font-size: 20px"
                      class="fab fa-twitter-square"
                    ></i>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout class="mt-4 mb-5" v-else>
            <v-flex>
              <v-layout>
                <v-flex shrink>
                  <span
                    style="font-size: 22px"
                    :style="{
                      'font-size': $vuetify.breakpoint.lgAndUp
                        ? '22px'
                        : '' || $vuetify.breakpoint.mdAndUp
                        ? '22px'
                        : '' || $vuetify.breakpoint.smAndUp
                        ? '22px'
                        : '' || $vuetify.breakpoint.smAndDown
                        ? '11px'
                        : '',
                    }"
                  >
                    {{
                      switchLanguage === "th"
                        ? category_collection_data.category_collection_name_th
                        : category_collection_data.category_collection_name_en
                    }}
                  </span>
                </v-flex>
                <v-flex shrink class="mx-2">
                  <v-icon v-if="$vuetify.breakpoint.smAndUp" color="#000"
                    >navigate_next</v-icon
                  >
                  <v-icon v-else small color="#000">navigate_next</v-icon>
                </v-flex>
                <v-flex shrink>
                  <span
                    style="color: #FD5246"
                    :style="{
                      'font-size': $vuetify.breakpoint.lgAndUp
                        ? '22px'
                        : '' || $vuetify.breakpoint.mdAndUp
                        ? '22px'
                        : '' || $vuetify.breakpoint.smAndUp
                        ? '22px'
                        : '' || $vuetify.breakpoint.smAndDown
                        ? '11px'
                        : '',
                    }"
                  >
                    {{
                      switchLanguage === "th"
                        ? collections_by_id.collection_name_th
                        : collections_by_id.collection_name_th
                    }}
                  </span>
                </v-flex>
                <v-spacer></v-spacer>
              </v-layout>

              <v-layout pr-4>
                <v-flex>
                  <v-layout>
                    <v-flex class="d-flex align-center">
                      <span style="color: #C4C4C4;font-size: 12px">
                        {{ $t("update-date") }} :
                        {{
                          switchLanguage === "th"
                            ? collections_by_id.date_th
                            : collections_by_id.date_en
                        }}
                      </span>
                    </v-flex>
                  </v-layout>

                  <v-layout>
                    <v-spacer></v-spacer>
                    <v-flex shrink class="d-flex align-center">
                      <v-icon class="mr-2">remove_red_eye</v-icon>
                      <span>{{ total }}</span>
                    </v-flex>
                    <v-divider class="mx-4" vertical></v-divider>
                    <v-flex class="text-end d-flex align-center" shrink>
                      <v-layout>
                        <!-- Share Facebook -->
                        <v-flex mr-3 shrink>
                          <ShareNetwork
                            :title="collections_by_id.collection_name_th"
                            id="share-collection-facebook"
                            network="facebook"
                            :url="
                              `${url}api/share-collection-facebook/` +
                                $route.query.collection_id
                            "
                          ></ShareNetwork>
                          <v-btn
                            depressed
                            small
                            color="#4365FF"
                            @click="share('facebook')"
                          >
                            <v-icon small color="#fff" class="mr-2"
                              >share</v-icon
                            >
                            <i
                              style="color: #fff; font-size: 20px"
                              class="fab fa-facebook"
                            ></i>
                          </v-btn>
                        </v-flex>
                        <!-- Share Twitter -->
                        <v-flex shrink>
                          <ShareNetwork
                            :title="collections_by_id.collection_name_th"
                            id="share-collection-twitter"
                            network="twitter"
                            :url="
                              `${url}api/share-collection-twitter/` +
                                $route.query.collection_id
                            "
                          ></ShareNetwork>
                          <v-btn
                            depressed
                            small
                            color="#49B1FF"
                            @click="share('twitter')"
                          >
                            <v-icon small color="#fff" class="mr-2"
                              >share</v-icon
                            >
                            <i
                              style="color: #fff; font-size: 20px"
                              class="fab fa-twitter-square"
                            ></i>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>

          <!-- date -->
          <v-layout v-if="$vuetify.breakpoint.mdAndUp">
            <v-flex class="text-start pr-6 mb-4">
              <span style="color: #C4C4C4;font-size: 12px">
                {{ $t("update-date") }} :
                {{
                  switchLanguage === "th"
                    ? collections_by_id.date_th
                    : collections_by_id.date_en
                }}
              </span>
            </v-flex>
          </v-layout>

          <v-layout class="mt-lg-0 mt-md-0 mt-sm-0 mt-4" wrap>
            <v-flex lg5 pr-lg-4 pr-md-4 pr-sm-0 pr-0>
              <img
                width="100%"
                :src="
                  collections_by_id.cover_path
                    ? url +
                      imgPath +
                      'images_collection/' +
                      collections_by_id.cover_path
                    : require('../../assets/tcdc-color.png')
                "
              />
            </v-flex>
            <v-flex lg7>
              <div style="color: #FD5246;font-size: 20px">
                {{ collections_by_id.collection_name_th }}
              </div>
              <div
                v-html="
                  switchLanguage === 'th'
                    ? collections_by_id.description_th
                    : collections_by_id.description_en
                "
              ></div>
            </v-flex>
          </v-layout>

          <v-layout style="margin-top: 5rem">
            <v-flex>
              <!-- content -->
              <v-container fluid pa-0>
                <!-- PORTFOLIO -->
                <v-row v-if="portfolios_lenght === 0">
                  <v-col class="text-center">
                    <span v-if="switchLanguage === 'th'">ไม่มีข้อมูล</span>
                    <span v-if="switchLanguage === 'EN'">data not found</span>
                  </v-col>
                </v-row>

                <v-row v-else>
                  <v-col
                    v-for="(item, i) in portfolios"
                    :key="i"
                    :cols="
                      $vuetify.breakpoint.lgAndUp
                        ? 3
                        : '' || $vuetify.breakpoint.md
                        ? 4
                        : '' || $vuetify.breakpoint.sm
                        ? 6
                        : '' || $vuetify.breakpoint.xs
                        ? 12
                        : ''
                    "
                    v-if="item.portfolio"
                    @click="viewPortDetail(item.portfolio)"
                  >
                    <v-hover v-slot:default="{ hover }">
                      <div style="cursor: pointer" v-if="item.portfolio">
                        <div>
                          <v-img
                            width="100%"
                            height="100%"
                            style="border-top-left-radius: 5px;border-top-right-radius: 5px;"
                            aspect-ratio="1"
                            :src="
                              item.portfolio.cover_img_path
                                ? url +
                                  imgPath +
                                  'images_cover/' +
                                  item.portfolio.cover_img_path
                                : require('../../assets/tcdc-color.png')
                            "
                            :contain="
                              item.portfolio.cover_img_path ? false : true
                            "
                          >
                            <v-expand-transition>
                              <div
                                v-if="hover"
                                class="d-flex transition-fast-in-fast-out black darken-2 v-card--reveal display-3 white--text"
                                style="height: 100%;"
                              >
                                <span
                                  v-if="switchLanguage === 'th'"
                                  style="font-size: 16px;font-weight: bold"
                                  class="text-uppercase"
                                  >ดูข้อมูล</span
                                >
                                <span
                                  v-if="switchLanguage === 'en'"
                                  style="font-size: 16px;font-weight: bold"
                                  class="text-uppercase"
                                  >see detail</span
                                >
                              </div>
                            </v-expand-transition>
                          </v-img>
                        </div>
                        <v-layout
                          style="background-color: #FFFFFF;padding: 10px;border-bottom-left-radius: 5px;border-bottom-right-radius: 5px;"
                        >
                          <v-flex shrink class="d-flex align-center mr-3">
                            <v-img
                              v-if="$vuetify.breakpoint.smAndUp"
                              style="border-radius: 100%"
                              :src="checkImage(item.portfolio)"
                              class="white--text align-end"
                              gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                              width="30px"
                              height="30px"
                            >
                            </v-img>
                            <v-img
                              v-else
                              style="border-radius: 100%"
                              :src="
                                item.portfolio.profile
                                  ? item.portfolio.profile.avatar
                                    ? url +
                                      imgPath +
                                      'images_profile/' +
                                      item.portfolio.profile.avatar
                                    : require('../../assets/user_profile.png')
                                  : require('../../assets/user_profile.png')
                              "
                              class="white--text align-end"
                              gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                              width="40px"
                              height="40px"
                            >
                            </v-img>
                          </v-flex>
                          <v-flex>
                            <v-layout>
                              <v-flex>
                                <span class="one-line">
                                  {{ item.portfolio.project_title }}
                                </span>
                              </v-flex>
                            </v-layout>
                            <v-layout>
                              <v-flex>
                                <span class="one-line" style="font-size: 14px">
                                  {{ $t("by") }} {{ checkName(item.portfolio) }}
                                </span>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </div>
                    </v-hover>
                  </v-col>
                </v-row>
                <div class="text-center mt-12">
                  <v-btn
                    v-if="
                      portfolio_data.current_page !==
                        portfolio_data.last_page && portfolio_data.total !== 0
                    "
                    depressed
                    dark
                    style="background-color: #FD5246"
                    :loading="btnLoading"
                    @click="getMoreCollectionPortfolio(portfolios_current_page)"
                  >
                    <span>{{ $t("more") }}</span>
                  </v-btn>
                </div>
              </v-container>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card>
  </v-content>
</template>

<script>
import SlideGroupPortfolio from "../../components/slide_group/SlideGroupPortfolio";
import { domain, imgPath } from "../../services/Constants";
import { mapState } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import CardContent from "../../components/card_content/CardContent";

export default {
  name: "CuratedDebut",
  components: {
    SlideGroupPortfolio,
    Loading,
  },
  computed: {
    ...mapState({
      collection_id: (state) => {
        return state.Collection.collection_id;
      },
      collections: (state) => {
        return state.Collection.collections;
      },
      category_collection_data: (state) => {
        return state.Collection.category_collection_data;
      },
      switchLanguage: (state) => {
        return state.Common.switchLanguage;
      },
    }),
  },
  data: () => ({
    isLoading: false,
    btnLoading: false,
    fullPage: true,
    page: 1,
    portfolios: [],
    portfolio_data: [],
    portfolios_lenght: null,
    portfolios_current_page: 1,
    designers: [],
    designers_data: [],
    designers_lenght: null,
    designers_current_page: 1,
    imgPath: imgPath,
    url: domain,
    tab: null,
    total: null,
    collections_by_id: [],
  }),
  created() {
    this.getCollectionPortfolio(1);
    this.getDataCollectionPortfolio();
  },
  methods: {
    viewPortDetail(port) {
      // let slug =
      //   port.profile.mem_info && port.profile.mem_info.domain_name
      //     ? port.profile.mem_info.domain_name
      //     : port.profile.profile_id;
      // this.$router.push({
      //   path: `/detail-portfolio/${slug}`,
      //   query: { id: port.portfolio_id, pfid: port.profile.profile_id },
      // });
      let domain_slug =
        port.profile.mem_info && port.profile.mem_info.domain_name
          ? port.profile.mem_info.domain_name
          : port.profile.profile_id;
      this.$router.push({
        path: `/profile/${domain_slug}/${port.portfolio_id}`,
      });
    },

    getCollectionPortfolio(page) {
      let data = {
        id: this.$route.query.collection_id,
        page: page,
      };
      this.isLoading = true;
      this.$store
        .dispatch("Collection/getCollectionPortfolio", data)
        .then((res) => {
          this.total = res.data.total;
          this.portfolios = res.data.collection_ports.data;
          this.portfolios_lenght = res.data.collection_ports.data.length;
          this.portfolio_data = res.data.collection_ports;
          this.portfolios_current_page =
            res.data.collection_ports.current_page + 1;
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
        });
    },
    getMoreCollectionPortfolio(page) {
      let data = {
        id: this.$route.query.collection_id,
        page: page,
      };
      this.btnLoading = true;
      // this.$store.dispatch('Collection/getMoreCollectionPortfolio', data).then(res => {
      this.$store
        .dispatch("Collection/getCollectionPortfolio", data)
        .then((res) => {
          // merge ข้อมมูลเก่ากับข้อมูลใหม่
          const data = [...this.portfolios, ...res.data.collection_ports.data];

          this.portfolios = data;
          this.portfolios_lenght = res.data.collection_ports.data.length;
          this.portfolio_data = res.data.collection_ports;
          this.portfolios_current_page =
            res.data.collection_ports.current_page + 1;
          this.btnLoading = false;
        })
        .catch((err) => {
          this.btnLoading = false;
        });
    },
    getCollectionById(val) {
      let data = {
        id: val,
        page: 1,
        custom_paginate: 0,
      };
      this.isLoading = true;
      this.$store
        .dispatch("Collection/getCollectionById", data)
        .then((res) => {
          this.isLoading = false;
          this.$router.push("/creator");
        })
        .catch((err) => {
          console.log(err);
          this.isLoading = false;
        });
    },

    checkImage(val) {
      if (val.profile && val.profile.mem_info && val.profile.mem_info.avatar) {
        return (
          this.url +
          this.imgPath +
          "images_profile/" +
          val.profile.mem_info.avatar
        );
      }
      return require("../../assets/user_profile.png");
    },
    checkName(val) {
      if (val.profile) {
        if (!val.profile.name_th && !val.profile.last_th) {
          return val.profile.email;
        } else {
          if (val.profile.name_th && val.profile.last_th) {
            return val.profile.name_th + " " + val.profile.last_th;
          } else {
            return val.profile.name_th;
          }
        }
      } else {
        return "";
      }
    },
    hastag() {
      return this.tags.map((tag) => tag.name).join(",");
    },
    share(val) {
      switch (val) {
        case "facebook":
          document.getElementById("share-collection-facebook").click();
          break;
        case "twitter":
          document.getElementById("share-collection-twitter").click();
          break;
      }
    },

    getDataCollectionPortfolio() {
      this.isLoading = true;
      this.$store
        .dispatch("Collection/onGetCollectionById", this.$route.query.id)
        .then((res) => {
          this.isLoading = false;
          this.collections_by_id = res;
        })
        .catch((e) => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style>
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: 0.65;
  position: absolute;
  width: 100%;
}
</style>
